import { TEST_RIDE_BOOK_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export async function bookTestRide(testRideData) {
    const response = await Network.post(TEST_RIDE_BOOK_ENDPOINT, testRideData);
    return response.data;
}
